var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'i18next';
import { twMerge } from 'tailwind-merge';
import { CopyIcon, SmallCheckIcon } from '../../SVG';
import '../Types';
var WarningTooltip = function (_a) {
    var message = _a.message;
    return (React.createElement("div", { className: "invisible absolute right-full top-1/2 mr-2 -translate-y-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white opacity-0 transition-all group-hover:visible group-hover:opacity-100" }, message));
};
var CopyButton = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled, copied = _a.copied, buttonText = _a.buttonText, copiedText = _a.copiedText, tooltipText = _a.tooltipText;
    return (React.createElement("div", { className: "group relative" },
        React.createElement("button", { onClick: onClick, disabled: disabled, className: twMerge('flex h-8 min-w-50 items-center justify-start gap-1.5 rounded-md px-3 text-[11px] font-medium shadow-md transition-all duration-200', copied
                ? 'border border-green-200 bg-green-50 text-green-700 hover:bg-green-100 hover:shadow-lg'
                : 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 hover:shadow-lg', disabled && 'cursor-not-allowed bg-gray-100 text-gray-400 hover:bg-gray-100 hover:shadow-md') }, copied ? (React.createElement(React.Fragment, null,
            React.createElement(SmallCheckIcon, { className: "h-3.5 w-3.5" }),
            copiedText)) : (React.createElement(React.Fragment, null,
            React.createElement(CopyIcon, { className: "h-3.5 w-3.5" }),
            buttonText))),
        disabled && tooltipText && React.createElement(WarningTooltip, { message: tooltipText })));
};
var CopyConversationControls = function (_a) {
    var complaint = _a.complaint, education = _a.education, conversationId = _a.conversationId, messages = _a.messages;
    var _b = useState(false), copiedComplaint = _b[0], setCopiedComplaint = _b[1];
    var _c = useState(false), copiedMessages = _c[0], setCopiedMessages = _c[1];
    var _d = useState(false), copiedEducation = _d[0], setCopiedEducation = _d[1];
    var t = useTranslation().t;
    var handleCopy = function (text, setCopiedState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!text) return [3 /*break*/, 2];
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 1:
                    _a.sent();
                    setCopiedState(true);
                    setTimeout(function () {
                        setCopiedState(false);
                    }, 2000);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyComplaint = function () { return __awaiter(void 0, void 0, void 0, function () {
        var textToCopy, response, data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    textToCopy = complaint;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch("/conversations/".concat(conversationId, "/nlp"))];
                case 2:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (Array.isArray(data.labels) && data.labels.length > 0) {
                        textToCopy = data.labels.join(', ');
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    // fallback to complaint
                    console.error('Error fetching NLP labels for complaint (falls back to complaint):', e_1);
                    return [3 /*break*/, 6];
                case 6:
                    handleCopy(textToCopy, setCopiedComplaint);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleCopyMessages = function () {
        var fullConvo = messages.map(function (message) { return message.text; }).join('\n');
        handleCopy(fullConvo, setCopiedMessages);
    };
    // Convert clearstep customized markdown to standard markdown with dropdowns
    var cleanEducationMarkdown = function (markdown) {
        if (!markdown)
            return '';
        // Add blank line after <details> tag
        var cleaned = markdown.replace(/<details>/g, '<details>\n');
        // Convert headers within details tags to summary tags and ensure blank line after
        cleaned = cleaned.replace(/(<details>[\s\n]+)(#\s*)(.*?)(\n|$)/g, function (match, detailsTag, hash, heading) { return "".concat(detailsTag, "<summary>").concat(heading.trim(), "</summary>\n\n"); });
        // Ensure there's always a blank line after summary tags (if not already present)
        // cleaned = cleaned.replace(/(<\/summary>)(?!\n\n)/g, '$1\n\n');
        return cleaned;
    };
    // Extract only the first title and first details section from education content
    var extractFirstSection = function (markdown) {
        if (!markdown)
            return '';
        // Regular expression to find the first title (# Title) and the first <details> section
        var firstSectionRegex = /(#+\s+[^\n]+)[\s\S]*?(<details>[\s\S]*?<\/details>)/;
        var match = markdown.match(firstSectionRegex);
        if (match && match.length >= 3) {
            // Return title plus the first details section
            return "".concat(match[1], "\n\n").concat(match[2]);
        }
        // If no match, return the original markdown (fallback)
        return markdown;
    };
    var handleCopyEducation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var nlpResponse, nlpData, complaintIds, educationTexts, validEducationTexts, combinedEducation, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, fetch("/conversations/".concat(conversationId, "/nlp"))];
                case 1:
                    nlpResponse = _a.sent();
                    if (!nlpResponse.ok) {
                        throw new Error('Failed to fetch complaints from NLP endpoint');
                    }
                    return [4 /*yield*/, nlpResponse.json()];
                case 2:
                    nlpData = _a.sent();
                    complaintIds = [];
                    if (nlpData.complaints &&
                        Array.isArray(nlpData.complaints) &&
                        nlpData.complaints.length > 0) {
                        complaintIds = nlpData.complaints.map(function (complaint) { return complaint.id; });
                    }
                    else if (Array.isArray(nlpData.labels) && nlpData.labels.length > 0) {
                        // Backward compatibility check
                        console.warn('Using deprecated labels field instead of complaints');
                    }
                    if (complaintIds.length === 0) {
                        // No complaint IDs available to fetch education for
                        showFallbackEducation(education);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, Promise.all(complaintIds.map(function (complaintId) { return __awaiter(void 0, void 0, void 0, function () {
                            var educationResponse, educationData, e_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, , 4]);
                                        return [4 /*yield*/, fetch("/complaints/".concat(complaintId, "/education"))];
                                    case 1:
                                        educationResponse = _a.sent();
                                        if (!educationResponse.ok) {
                                            console.error("Error fetching education for complaint ID \"".concat(complaintId, "\":"), educationResponse.statusText);
                                            return [2 /*return*/, null];
                                        }
                                        return [4 /*yield*/, educationResponse.json()];
                                    case 2:
                                        educationData = _a.sent();
                                        // Extract only the first section from the education content
                                        return [2 /*return*/, educationData.education ? extractFirstSection(educationData.education) : null];
                                    case 3:
                                        e_3 = _a.sent();
                                        console.error("Error fetching education for complaint ID \"".concat(complaintId, "\":"), e_3);
                                        return [2 /*return*/, null];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 3:
                    educationTexts = _a.sent();
                    validEducationTexts = educationTexts.filter(Boolean);
                    if (validEducationTexts.length > 0) {
                        combinedEducation = validEducationTexts
                            .map(cleanEducationMarkdown)
                            .join('\n\n---\n\n');
                        handleCopy(combinedEducation, setCopiedEducation);
                    }
                    else if (education) {
                        // Fall back to the existing education if no new education was found
                        showFallbackEducation(education);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _a.sent();
                    console.error('Error in handleCopyEducation:', e_2);
                    showFallbackEducation(education);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var showFallbackEducation = function (education) {
        if (education) {
            var formattedContent = cleanEducationMarkdown(extractFirstSection(education));
            handleCopy(formattedContent, setCopiedEducation);
        }
    };
    return (React.createElement("div", { className: "fixed right-5 top-[100px] z-50 flex flex-col gap-2" },
        React.createElement(CopyButton, { onClick: handleCopyComplaint, disabled: !complaint, copied: copiedComplaint, buttonText: t('copyComplaint.button', 'Copy Complaint'), copiedText: t('copyComplaint.copied', 'Copied!'), tooltipText: !complaint ? t('copyComplaint.tooltip', 'Complaint not yet determined') : undefined }),
        React.createElement(CopyButton, { onClick: handleCopyMessages, disabled: !(messages === null || messages === void 0 ? void 0 : messages.length), copied: copiedMessages, buttonText: t('copyMessages.button', 'Copy Conversation Messages'), copiedText: t('copyMessages.copied', 'Copied!') }),
        React.createElement(CopyButton, { onClick: handleCopyEducation, disabled: !education, copied: copiedEducation, buttonText: t('copyEducation.button', 'Copy Education'), copiedText: t('copyEducation.copied', 'Copied!'), tooltipText: !education ? t('copyEducation.tooltip', 'Education not yet determined') : undefined })));
};
export default CopyConversationControls;
